module.exports = __webpack_public_path__ + "06_mole.d616595b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/06_mole.png
// module id = FbYh
// module chunks = 0